import PropTypes from 'prop-types'
import styles from './PillHighlight.module.css'

const COLORS = ['amarillo', 'menta', 'violeta']

export function PillHighlight({ color = 'amarillo', icon, className = '', children }) {
  const classes = [
    styles.pillHighlight,
    styles[color],
    className,
  ].filter(Boolean).join(' ')

  return (
    <span className={classes}>
      {icon}
      {children}
    </span>
  )
}

PillHighlight.propTypes = {
  color: PropTypes.oneOf(COLORS),
  icon: PropTypes.node,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
}
